// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SH9Hq","outer":"styles_outer__7Jwqb"};